import {Filter} from "@/features/catalog-filters";

type Params = {
    filter: Filter;
    isDesktop: boolean;
    withVisibility?: boolean;
};

export const mapCatalogFilter = (
    {
        filter,
        isDesktop,
        withVisibility = true,
    }: Params
): Filter => {
    const visibleOptionsCount = isDesktop ? filter.visibleOptionsCountDesktop : filter.visibleOptionsCountMobile;

    return {
        ...filter,
        visible: withVisibility
            ? filter.visible && (isDesktop ? filter.visibleDesktop : filter.visibleMobile)
            : filter.visible,
        visibleOptionsCount,
    };
};
